const publicImagePath = '/assets/images';

export const noImageIcon = `${publicImagePath}/icons/no_img.svg`;
export const noFolderIcon = `${publicImagePath}/no_data/no_folder.svg`;
export const errorDataIcon = `${publicImagePath}/no_data/error_data.svg`;